module.exports = __webpack_public_path__ + "img/features_default.d0c25d06.png";